<template>
  <div class="ly-table">
    <div class="table-header">
      <span class="table-title"
        >{{ $t("messages.titTblSubServiceContractInfo") }}
      </span>
    </div>
    <div class="ly-flex">
      <div class="ly-sort ly-sort-his">
        <div class="sort-count">
          <p class="table-cell-all">
            {{ $t("messages.all") }} <span class="table-cell-count">{{ count }}</span
            >{{ $t("messages.unit") }}
          </p> 
        </div>
      </div>
    </div>
    <div class="table-body">
      <idc-table :tableData="tableData" :tableHeader="tableHeader" :height="300"/>
    </div>
  </div>
</template>

<script>
import IdcTable from "@/components/common/IdcTable";

export default {
  props: {
    custId: {
      default: "",
    },
  },
  components: {
    IdcTable,
  },
  data() {
    return {
      tableData: [],
      tableHeader: [
        {
          prop: "idcCdNm",
          label: "DC",
          width: 97,
        },
        {
          prop: "svcSttusCdHnglNm",
          // label: "서비스상태",
          label: this.$t("messages.lblServiceState"),
          width: 100,
        },
        {
          prop: "svcNo",
          // label: "서비스번호",
          label: this.$t("messages.lblServiceNumber"),
          width: 136,
        },
        {
          prop: "svcContId",
          // label: "서비스 계약 ID",
          label: this.$t("messages.lblSvcContId"),
          width: 136,
        },
        {
          prop: "svcItemIcisCdNm",
          // label: "서비스유형",
          label: this.$t("messages.lblDtlClassificate"),
          width: 300,
        },
        {
          prop: "svcItemIcisDtlCdNm",
          // label: "서비스 상세 유형",
          label: this.$t("messages.lblDtlType"),
          width: 272,
        },
        {
          prop: "itemQnty1",
          // label: "서비스 수량",
          label: this.$t("messages.lblQuantity"),
          width: 104,
        },
      ],
      srchSvcSttusCd : "N"
    };
  },
  computed: {
    count() {
      return this.tableData.length;
    },
  },
  watch: {
    svcNo() {
      this.getAdtnSvcContList();
    },
  },
  created() {},
  mounted() {
    this.$store.dispatch("userInfoStore/getCustLoginCustInfo").then(data => {
      this.custId = data.custId;
      this.getAdtnSvcContList();
    });
  },
  methods: {
    getAdtnSvcContList() {
      this.$BIZ_SERVICE
      .post(this.$API_URLS.Cus.getAdtnSvcContList, {
        custId: this.custId,
        srchSvcSttusCd : this.srchSvcSttusCd
      })
      .then((res) => {
        if (res.data) {
          this.tableData = res.data.resData;
        } else {
          this.tableData = [];
        }

      })
      .catch((error) => {
          
      }).finally(()=>{
          
      });
    },
  }
};
</script>

<style></style>
